namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_float_table_novirt, {
		
		Cell_text: {
			whiteSpace: 'normal',
			position: 'relative',
		},

		Cell_checkbox: {
			padding: 0,
		},

		Cell_file: {
			padding: 0,
		},

		Cell_delete: {
			padding: 0,
		},

		Cell_edit: {
			padding: 0,
		},
		
	} )
	
}
